var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCashOnDelivery = function SvgCashOnDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 69 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4496"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3c83f7",
    d: "M69.001 17.26V36h-6.693V17.26Zm0 0",
    "data-name": "Path 18980"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec9a3",
    d: "M62.305 21.275v12.047h-9.37l-11.886-3.561a10.39 10.39 0 0 0-3.065-.455H27.505a5.347 5.347 0 0 1 5.354-5.354h5.354a4.016 4.016 0 1 0 0-8.031h-5.354v-5.354h10.708l10.708 10.708Zm0 0",
    "data-name": "Path 18981"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7bb8f",
    d: "M43.836 10.708h-8.031l-2.677-2.677a5.671 5.671 0 0 1 0-8.031Zm0 0",
    "data-name": "Path 18982"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11cb50",
    d: "M33.464 15.976v8.031a5.347 5.347 0 0 0-5.354 5.355H0v-18.74h33.464Zm-12.047 2.677a4.016 4.016 0 1 0-4.017 4.016 4.016 4.016 0 0 0 4.017-4.016m0 0",
    "data-name": "Path 18983"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16a848",
    d: "M21.539 18.666a4.268 4.268 0 1 1-4.267-4.268 4.268 4.268 0 0 1 4.267 4.268m0 0",
    "data-name": "Path 18984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7bb8f",
    d: "M34.474 9.37h8.031L33.136 0a5.671 5.671 0 0 0 0 8.031Zm0 0",
    "data-name": "Path 18985"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#16a848",
    "data-name": "Group 4495"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.017 19.996v-2.677a2.677 2.677 0 0 0 2.677-2.677h2.677a5.354 5.354 0 0 1-5.354 5.354m0 0",
    "data-name": "Path 18986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.371 25.35H6.694a2.677 2.677 0 0 0-2.677-2.677v-2.677a5.354 5.354 0 0 1 5.354 5.354m0 0",
    "data-name": "Path 18987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.449 19.996a5.354 5.354 0 0 1-5.354-5.354h2.677a2.677 2.677 0 0 0 2.677 2.677Zm0 0",
    "data-name": "Path 18988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.772 25.35h-2.677a5.354 5.354 0 0 1 5.354-5.354v2.677a2.677 2.677 0 0 0-2.677 2.677m0 0",
    "data-name": "Path 18989"
  })))));
};
export default SvgCashOnDelivery;